import React from 'react';
import RoomTable from '@/page/customer/RoomPage/RoomTable';
import AppLayout from '@/page/component/AppLayout';
import AppLayoutHeader from '@/page/component/AppLayout/AppLayoutHeader';

// 可以作为组件在继承中使用
export default function TransferPageRoomPage() {
    return (
        <AppLayout header={<AppLayoutHeader subTitle="客户群管理" />}>
            <div style={{overflowY: 'auto'}}>
                <RoomTable roomKeys={[]} />
            </div>
        </AppLayout>
    );
}
